import { Section, Eyebrow, Heading, P, Statement, PullQuote, Aside } from "../Chapter";

export const Scribe = () => (
    <Section className="bg-surface">
        <Eyebrow>II. The scribe</Eyebrow>
        <Heading>The man who read your letters for you</Heading>

        <P>There is a detail about the old world that gets left out of the romantic version.</P>

        <Statement>Most people couldn't read.</Statement>

        <P>
            So outside every large post office in India there sat a letter-writer — a scribe with a
            low desk, a pen, and a stack of paper, who wrote your letter for you for a few paise. A
            woman would come with news for a husband working in another city. She would speak; he
            would write. Then, when the reply came, she would return to the same desk to have it
            read back to her.
        </P>

        <PullQuote>
            Which means the most private words in a person's life passed through a stranger, twice.
        </PullQuote>

        <P>
            The scribes were discreet, and they were also editors. They knew the formulas — how to
            open a letter to an elder, how to phrase a request for money without shame, how to break
            bad news gently. People trusted them with grief, debt, marriage proposals, and death. A
            good letter-writer knew half the secrets on his street and repeated none of them.
        </P>
        <P delay={0.05}>
            They are almost gone now. A handful still sit outside old post offices, mostly filling
            out forms.
        </P>

        <Aside>
            If you have ever asked a machine to phrase something difficult for you, you are doing
            something very old.
        </Aside>
    </Section>
);
